import { c as _c } from "react/compiler-runtime";
import SpecificTriggerRules from 'modules/automation-rules/specific-trigger-rules';
import { getDefaultTriggerValue } from 'modules/automation-rules/triggers/utils/get-default-trigger-value';
import { useFunnelStepRuleData } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rule-data';
import { useFunnelStepRules } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rules';
import { useFunnelStepTriggers } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-triggers';
import { fillTriggerWithFunnelData } from 'modules/funnels/funnel/components/funnel-rules/utils/fill-trigger-with-funnel-data';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { splitRelatedAndUnrelatedTriggers } from '../utils/split-related-and-unrelated-triggers';
interface AutomationRulesSectionProps {
  funnelStepId?: FunnelStepId;
  funnelId: FunnelId;
}
function AutomationRulesTab(t0) {
  const $ = _c(12);
  const {
    funnelId,
    funnelStepId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const specificTriggerRulesData = useFunnelStepRules(funnelStepId);
  const availableTriggersData = useFunnelStepTriggers(funnelStepId);
  const {
    funnelTriggerData
  } = useFunnelStepRuleData(funnelId, funnelStepId);
  let t1;
  if ($[0] !== t) {
    t1 = id => <TransLoco t={t} components={{
      a: <LinkWithoutPrefetch href={`/automation-rules/${id}`} className="link" />
    }} i18nKey="dashboard.automation_rule.trigger.has_non_related" />;
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== funnelTriggerData?.funnelStepId) {
    t2 = triggers => splitRelatedAndUnrelatedTriggers(triggers, funnelTriggerData?.funnelStepId);
    $[2] = funnelTriggerData?.funnelStepId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== funnelTriggerData) {
    t3 = funnelTriggerData && ((trigger, maxTriggerId) => fillTriggerWithFunnelData(getDefaultTriggerValue(trigger, maxTriggerId), funnelTriggerData));
    $[4] = funnelTriggerData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== availableTriggersData || $[7] !== specificTriggerRulesData || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <><SpecificTriggerRules noRelatedMessage={t1} availableTriggersData={availableTriggersData} specificTriggerRulesData={specificTriggerRulesData} getRelatedAndUnrelatedTriggersData={t2} customAddTriggerHandler={t3} /></>;
    $[6] = availableTriggersData;
    $[7] = specificTriggerRulesData;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export default AutomationRulesTab;